$(".slider-testimonials").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll:1
});
$('.marquee').marquee({
    duration: 20000,
    gap: 50,
    padding:20,
    direction: 'left',
    delayBeforeStart: 0,
    startVisible: true,
    duplicated: true
});
var filterActive;
function filterCategory(category) {
    if (filterActive != category) {
        // reset results list
        $('.filter-cat-results .f-cat').removeClass('active');

        // elements to be filtered
        $('.filter-cat-results .f-cat')
            .filter('[data-cat="' + category + '"]')
            .addClass('active');

        // reset active filter
        filterActive = category;
        $('.filtering button').removeClass('active');
    }
}
$('.f-cat').addClass('active');
$('.filtering button').click(function() {
    if ($(this).hasClass('cat-all')) {
        $('.filter-cat-results .f-cat').addClass('active');
        filterActive = 'cat-all';
        $('.filtering button').removeClass('active');
    } else {
        filterCategory($(this).attr('data-cat'));
    }
    $(this).addClass('active');
});
